export default "__VITE_ASSET__Cpw2nxng__"